import React from 'react'

export default function YearlySalesFooterStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .content-footer-container {
          display: flex;
          font-size: 1rem;
          padding: 5px;
          justify-content: flex-end;
        }
        .add-on-controls {
          font-size: 1.2em;
          display: flex;
          box-sizing: border-box;
          flex: 2;
        }
        .add-on-controls input[type='number'] {
          width: 100px;
          padding: 5px;
          text-align: center;
        }
        .year-nav-button { padding: 5px;}
      `}
      </style>
    </React.Fragment>
  )
}
